import { render, staticRenderFns } from "./ShippingFeeSubList.vue?vue&type=template&id=b1e86dc2&scoped=true"
import script from "./ShippingFeeSubList.vue?vue&type=script&lang=js"
export * from "./ShippingFeeSubList.vue?vue&type=script&lang=js"
import style0 from "./ShippingFeeSubList.vue?vue&type=style&index=0&id=b1e86dc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e86dc2",
  null
  
)

export default component.exports